import { html, LitElement } from 'lit-element';

/**
 * @element slots-wrapper
 * @prop {String} markup - Markup
 */
export class SlotsWrapper extends LitElement {
  parseMarkup() {
    const div = document.createElement('div');

    div.innerHTML = this.markup;

    // creating slots that have to replace item types
    const elements = Array.from(
      div.querySelectorAll(
        'math-inline, multiple-choice, explicit-constructed-response'
      )
    );

    elements.forEach(element => {
      const mySlot = document.createElement('slot');
      mySlot.name = `${element.tagName.toLowerCase()}-${element.id}`;

      element.parentElement.replaceChild(mySlot, element);
    });

    // creating slots for math elements
    const mathElements = Array.from(div.querySelectorAll('math'));

    mathElements.forEach((element, index) => {
      const mySlot = document.createElement('slot');
      mySlot.name = `math-element-${index}`;

      element.parentElement.replaceChild(mySlot, element);
    });

    return div.innerHTML;
  }

  render() {
    return html`
      <div>
        <math-rendering-element
          .label=${this.parseMarkup()}
        ></math-rendering-element>
      </div>
    `;
  }
}
